// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import Button from './bootstrap/Button';

const StandardHeader = ({
	hasBackButton,
	backButtonText,
	backButtonOnClick,
	supportButtonOnClick,
	logoUrl,
}) => {
	return (
		<div
			style={{
				backgroundColor: 'transparent',
				height: 'auto',
				padding: 0,
				display: 'flex', // Ensures the content is laid out in a row
				flexDirection: 'row', // Items are laid out in a row
				alignItems: 'top !important', // Align items vertically
				justifyContent: 'space-between', // Space between the items
			}}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					marginBottom: '0 !important',
				}}>
				{hasBackButton && (
					<Button
						color='info'
						icon='arrow_back'
						width='100'
						isOutline
						onClick={() => {
							backButtonOnClick();
						}}>
						{backButtonText}
					</Button>
				)}
				{logoUrl && (
					<img
						src={logoUrl}
						alt='OEM logo'
						style={{
							height: 'auto',
							margin: 'auto auto auto 0rem',
							marginBottom: '0 !important',
							marginLeft: hasBackButton ? '1rem' : '0',
							width: 'auto',
							maxHeight: '27px',
							maxWidth: '230px',
						}}
					/>
				)}
			</div>
			<div
				style={{
					width: '1px',
					backgroundColor: 'var(--bs-card-border-color)',
					marginLeft: '0.5rem',
					marginRight: '0.5rem',
					marginBottom: '0 !important',
				}}
			/>

			{/* Phone number section */}
			<Button
				color='info'
				isOutline
				icon='LocalPhone'
				width='100'
				style={{ marginBottom: '0 !important' }}
				onClick={() => {
					supportButtonOnClick();
				}}>
				Contact support
			</Button>
		</div>
	);
};

StandardHeader.propTypes = {
	hasBackButton: PropTypes.bool,
	backButtonOnClick: PropTypes.func.isRequired,
	supportButtonOnClick: PropTypes.func.isRequired,
	backButtonText: PropTypes.string,
	logoUrl: PropTypes.string.isRequired,
};

StandardHeader.defaultProps = {
	backButtonText: '',
	hasBackButton: false,
};

export default StandardHeader;
